var _span, _span2, _span3, _span4;
/* global caiprivacy */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, DisclaimerText } from 'reaxl';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FooterLegal(_ref) {
  let {
    className,
    onClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(DisclaimerText, {
    className: clsx(className, 'text-legal text-center'),
    "data-cmp": "txt-visitorAgreement",
    ...rest,
    children: [_span || (_span = /*#__PURE__*/_jsx("span", {
      children: "By using this service, you accept the terms of our\xA0"
    })), /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("a", {
        className: "display-inline-block padding-bottom-2",
        href: "/legal/visitor-agreement",
        ...(onClick && {
          onClick: event => {
            onClick(event, {
              type: 'additional',
              text: 'Visitor Agreement'
            });
            return true;
          }
        }),
        children: "Visitor Agreement"
      }, "visitorAgreement"), _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
        children: ". "
      }, "dot"))]
    }), /*#__PURE__*/_jsxs(Button, {
      className: "display-inline-block padding-bottom-2 padding-right-1",
      ...(onClick && {
        onClick: event => {
          onClick(event, {
            type: 'additional',
            text: 'Privacy Statement'
          });
          if (typeof caiprivacy !== 'undefined') {
            event.preventDefault();
            caiprivacy?.privacyStatement();
          }
          return true;
        }
      }),
      bsStyle: "text-decorated",
      children: ["Privacy Statement", _span3 || (_span3 = /*#__PURE__*/_jsx("span", {
        children: ". "
      }, "dot"))]
    }), /*#__PURE__*/_jsxs("span", {
      className: "margin-left-0",
      children: [/*#__PURE__*/_jsx("a", {
        className: "display-inline-block padding-bottom-4",
        href: "//www.autotrader.com/legal/accessibility-statement",
        ...(onClick && {
          onClick: event => {
            onClick(event, {
              type: 'additional',
              text: 'Accessibility Statement'
            });
            return true;
          }
        }),
        children: "Accessibility Statement"
      }, "accessibilityStatement"), _span4 || (_span4 = /*#__PURE__*/_jsx("span", {
        children: "."
      }, "dot"))]
    }), /*#__PURE__*/_jsxs("div", {
      "data-cmp": "txt-copyRight",
      children: ["\xA9", new Date().getFullYear() + ' ', "Autotrader, Inc. All Rights Reserved. \"Autotrader\" is a registered trademark of TPI Holdings, Inc. used under exclusive license."]
    })]
  });
}
export default FooterLegal;